import { lazy } from 'react';
const RegionMap = lazy(() => import('./RegionMap'));

const RegionMapRoutes = [
  {
    path: '/region-map',
    component: RegionMap
  }
];

export default RegionMapRoutes;
